module.exports = __webpack_public_path__ + "img/img-flow-3-4.6f03eb9c.png";